import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function MetricCard({
  title,
  value,
  unit,
  change,
  isImproving,
  trend,
  color,
  isSelected,
  onClick,
}) {
  const TrendIcon = trend === "up" ? TrendingUp : TrendingDown;
  const trendColor = isImproving ? "text-green-600" : "text-red-600";

  return (
    <Card
      className={`cursor-pointer transition-all duration-300 ${
        isSelected
          ? "bg-blue-100 border-blue-400 shadow-2xl scale-105"
          : "bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-xl hover:shadow-2xl"
      }`}
      onClick={onClick}
    >
      <CardContent className="p-4 flex flex-col justify-between h-full">
        <div>
          <div className="flex justify-between items-start">
            <h3 className="font-semibold text-slate-800 text-sm">{title}</h3>
            <div
              className={`flex items-center text-xs font-bold ${trendColor}`}
            >
              <TrendIcon className="w-4 h-4 mr-1" />
              <span>{Math.abs(change).toFixed(1)}</span>
            </div>
          </div>
        </div>
        <div className="mt-2 text-center">
          <span className="text-3xl font-bold" style={{ color: color }}>
            {value}
          </span>
          <span className="text-sm text-slate-500 ml-1">{unit}</span>
        </div>
      </CardContent>
    </Card>
  );
}
